import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { USER_KEY, userRole } from "../helper";
import { SEND_NOTIFICATION, SEND_WHATSAPP } from "./app";

// ເສັ້ນທາງທີ່ສິດ SECURITY ເຂົ້າໃຊ້ໄດ້
export const SECURITY_ROUTES = [SEND_NOTIFICATION, SEND_WHATSAPP];

function PrivateRoute({ children }) {
  const _local = localStorage.getItem(USER_KEY);
  const location = useLocation();

  if (!_local) {
    return <Navigate to="/login" replace />;
  }

  if (
    userRole() === "SECURITY" &&
    !SECURITY_ROUTES.includes(location.pathname)
  ) {
    return <Navigate to={SEND_NOTIFICATION} replace />;
  }

  return children;
}

export default PrivateRoute;
